// extracted by mini-css-extract-plugin
module.exports = {"table":"InfoTable_table__nBWO2","tableColumn":"InfoTable_tableColumn__1knzH","tableRow":"InfoTable_tableRow__3wuV1","tableCell":"InfoTable_tableCell__HUfmP"};